import { ChangeEvent, useEffect, useState } from "react";
import UserManagementPage from "./UserSelection";
import ZoneSelectionPage from "./ZoneSelection";
import {
  MessageRequest,
  Recipient, User, WhatsAppTemplate, Zone
} from "./types";

import { useNavigate } from "react-router-dom";
import TeamSelectionPage from "./TeamSelection";
import { fnRenderSmsPreview, fnRenderTemplateFields, fnRenderWhatsAppPreview } from "./render-utils";
import { Team } from "../../types/team";
import { Group } from "../group/types";
import GroupSelectionPage from "./GroupSelection";

export default function MessagingEmergencyPage() {

  const [data, setData] = useState({});
  const navigate = useNavigate()
  const recipients: User[] = []

  const [selectedTemplate, setSelectedTemplate] =
    useState<WhatsAppTemplate | null>(null);
  const [templateHeaderParameters, setTemplateHeaderParameters] = useState<
    Record<string, any>
  >({});
  const [templateBodyParameters, setTemplateBodyParameters] = useState<
    Record<string, any>
  >({});
  const [whatsappTemplates, setWhatsappTemplates] = useState<WhatsAppTemplate[]>([])
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [isWhatsappSelected, setIsWhatsappSelected] = useState(true);
  const [isSmsSelected, setIsSmsSelected] = useState(true);
  const [isWhatsappBodySms, setIsWhatsappBodySms] = useState(true);
  const [smsText, setSmsText] = useState("");

  const [sendStatus, setSendStatus] = useState<{
    success: boolean;
    message: string;
    job_id?: number;
  } | null>(null);
  const [isSending, setIsSending] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token")
    fetch("/api/messages/whatsapp-templates", { headers: { Authorization: `Bearer ${token}` } }).then(d => {
      d.json().then((d) => {
        const immediateTemplates = (d.data || []).filter((t: WhatsAppTemplate) => t?.name?.match(/emergency_immediate/i))
        const otherTemplates = (d.data || []).filter((t: WhatsAppTemplate) => t?.name?.match(/emergency/i) && immediateTemplates.findIndex((k:WhatsAppTemplate) => k.name === t.name) < 0)

        setWhatsappTemplates( [...immediateTemplates,...otherTemplates])
      })
    })
  }, [])


  const checkStatuses = () => {
    if ((selectedTemplate || (!isWhatsappBodySms && smsText && smsText !== "")))
      return true
    else
      return false
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!checkStatuses()) return;
    setShowConfirmation(true);
  };

  const handleWhatsappChannel = (e: React.ChangeEvent) => {
    setIsWhatsappSelected((e.target as HTMLInputElement).checked === true)
  }

  const handleSmsChannel = (e: React.ChangeEvent) => {
    setIsSmsSelected((e.target as HTMLInputElement).checked === true)
  }

  const handleConfirmSend = async (e: React.FormEvent) => {

    e.preventDefault();
    if (!checkStatuses()) return;


    setIsSending(true);
    setSendStatus(null);
    // setShowConfirmation(false);

    try {

      const token = localStorage.getItem("token");
      console.log(token);
      const messageRequest: MessageRequest = {
        whatsapp_message: {
          template_name: selectedTemplate!.name,
          header_parameters: templateHeaderParameters,
          body_parameters: templateBodyParameters
        },
        channels: {
          sms: isSmsSelected,
          whatsapp: isWhatsappSelected
        },
        recipient_member_ids: [],
        sms_message: { use_whatsapp_template: isWhatsappBodySms, text: smsText },
        zone_ids: [],
        group_ids: [],
        team_ids: [],

      };

      // alert(JSON.stringify(messageRequest));
      const response = await fetch("/api/batch-jobs/send-emergency-message", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(messageRequest),
      });

      const result = await response.json();

      if (result.status == "ok") {
        // Start polling for job status
        // const interval = setInterval(async () => {
        //   const statusResponse = await fetch(`/api/batch/${result.jobId}`);
        //   const statusData = await statusResponse.json();
        //   if (statusData.success) {
        //     const job = statusData.data;
        //     setCurrentJob(job);
        //     if (job.status === "completed" || job.status === "failed") {
        //       clearInterval(interval);
        //       setJobStatusInterval(null);
        //       setSendStatus({
        //         success: job.status === "completed",
        //         message:
        //           job.status === "completed"
        //             ? `Message sent successfully to ${job.successfulRecipients.length} recipients`
        //             : `Failed to send message to ${job.failedRecipients.length} recipients`,
        //       });
        //     }
        //   }
        // }, 1000);
        // setJobStatusInterval(interval);
        setSendStatus({
          success: true,
          message: "Batch Started",
          job_id: result.data.job_id
        });
      } else {
        setSendStatus({
          success: false,
          message: result.message,
        });
      }
    } catch (error) {
      setSendStatus({
        success: false,
        message: "Failed to send message",
      });
    } finally {
      setIsSending(false);
    }
  };

  const handleTemplateChange = (templateId: string) => {
    const template = whatsappTemplates.find((t) => t.id === templateId);
    setSelectedTemplate(template || null);
    setTemplateHeaderParameters({});
    setTemplateBodyParameters({});
  };

  const handleHeaderParameterChange = (name: string, value: any) => {
    setTemplateHeaderParameters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleBodyParameterChange = (name: string, value: any) => {
    setTemplateBodyParameters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const renderWhatsAppPreview = fnRenderWhatsAppPreview(selectedTemplate, templateHeaderParameters, templateBodyParameters);

  const handleCancelSend = () => {
    setShowConfirmation(false);
  };

  const handleDetailsButton = () => {
    if (sendStatus?.job_id)
      navigate(`/message-transactions/${sendStatus?.job_id}`)
  };

  const renderSmsPreview = fnRenderSmsPreview(selectedTemplate, templateBodyParameters, smsText);
  const renderTemplateFields = fnRenderTemplateFields(selectedTemplate, templateHeaderParameters, templateBodyParameters, handleHeaderParameterChange, handleBodyParameterChange)
  const renderConfirmationModal = () => {
    if (!showConfirmation) return null;
    const batchCount = recipients.length;
    const costPerWhatsApp = 1;
    const costPerSms = 1;
    const totalCost = batchCount * (costPerWhatsApp + costPerSms);
    return (
      <div className="fixed inset-0 z-50 flex  items-center justify-center bg-black bg-opacity-40">
        <div className="bg-white dark:bg-neutral-800 rounded-2xl shadow-xl max-w-2xl w-full p-8 relative">
          <h2 className="text-2xl font-semibold mb-4 dark:text-white">
            Confirm Notification
          </h2>
          <div className="mb-4">Please review your message before sending:</div>
          {renderWhatsAppPreview()}
          {renderSmsPreview()}
          <div className="mb-4">
            <div className="font-medium mb-1 dark:text-white">
              Recipients ({recipients.length}):
            </div>
            <div className="max-h-32 overflow-y-auto flex flex-wrap gap-2 scrollbar-thin scrollbar-thumb-neutral-400 scrollbar-track-neutral-200 dark:scrollbar-thumb-neutral-600 dark:scrollbar-track-neutral-800">
              {recipients.map((r) => (
                <div
                  key={r.id}
                  className="flex items-center bg-neutral-100 dark:bg-neutral-700 rounded px-2 py-1 text-sm mb-1"
                >
                  <img
                    src={r.avatar}
                    className="w-5 h-5 rounded-full mr-2"
                    alt={r.name}
                  />
                  <span className="text-neutral-800 dark:text-white">
                    {r.name}
                  </span>
                  <span title="WhatsApp user" className="ml-1">
                    <i className="fa-brands fa-whatsapp text-green-500"></i>
                  </span>
                  <span title="SMS user" className="ml-1">
                    <i className="fa-solid fa-sms text-blue-500"></i>
                  </span>
                </div>
              ))}
            </div>
          </div>
          <div className="mb-4 flex items-center gap-6">
            <div className="text-sm text-neutral-700 dark:text-neutral-300">
              Batch Count: <span className="font-semibold">{batchCount}</span>
            </div>
            <div className="text-sm text-neutral-700 dark:text-neutral-300">
              WhatsApp Cost:{" "}
              <span className="font-semibold">
                {batchCount * costPerWhatsApp}
              </span>{" "}
              credits
            </div>
            <div className="text-sm text-neutral-700 dark:text-neutral-300">
              SMS Cost:{" "}
              <span className="font-semibold">{batchCount * costPerSms}</span>{" "}
              credits
            </div>
            <div className="text-sm text-neutral-700 dark:text-neutral-300">
              Total Cost: <span className="font-semibold">{totalCost}</span>{" "}
              credits
            </div>
          </div>
          <div className="flex justify-end gap-4 mt-6">
            <button
              onClick={handleCancelSend}
              className="px-5 py-2 rounded-lg bg-neutral-200 dark:bg-neutral-700 text-neutral-800 dark:text-white font-medium hover:bg-neutral-300 dark:hover:bg-neutral-600 transition"
            >
              Cancel
            </button>
            <button
              onClick={handleConfirmSend}
              className="px-5 py-2 rounded-lg bg-blue-600 text-white font-semibold hover:bg-blue-700 transition flex items-center gap-2"
              disabled={isSending}
            >
              {isSending ? (
                <i className="fa-solid fa-spinner fa-spin"></i>
              ) : (
                <i className="fa-solid fa-paper-plane"></i>
              )}
              Confirm & Send
            </button>
          </div>
        </div>
      </div>
    );
  };


  const renderSendSuccess = () => {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
        <div className="bg-white dark:bg-neutral-800 rounded-2xl shadow-xl max-w-2xl w-full p-8 relative text-center">
          <h2 className="text-xl font-semibold mb-4 dark:text-white pb-8">
            Messages have been queued
          </h2>
          <div className="mb-4 w-full flex text-center flex flex-col items-center">
            <button
              onClick={handleDetailsButton}
              className="px-5 py-2 rounded-lg bg-gray-700 text-white font-medium hover:bg-blue-700 transition gap-2"
            >
              View Message Delivery Details
            </button>
          </div>
        </div>
      </div>)
  }


  function handleSmsTextOption(event: ChangeEvent<HTMLInputElement>): void {
    setIsWhatsappBodySms(!(event.target as HTMLInputElement).checked)
  }

  function handleSmsText(value: any): void {
    setSmsText(value)
  }

  return (
    <div className="min-h-[100vh] bg-neutral-50 dark:bg-neutral-900">
      <main className="container mx-auto px-4 py-2">
        <div className=" py-8 text-xl">Compose Message</div>
        <div className="bg-white dark:bg-neutral-700 rounded-2xl shadow-lg border dark:border-neutral-700 px-8 py-10 max-w-8xl mx-auto">
          <form className="space-y-8" onSubmit={handleSubmit}>
            <div className="space-y-2">
              <label className="block text-base font-medium text-neutral-800 dark:text-white mb-2">
                Delivery Channels
              </label>
              <div className="flex flex-wrap gap-6 items-center">
                <div className="flex items-center space-x-2">
                  <input
                    id="channel-sms"
                    name="channel-sms"
                    type="checkbox"
                    onChange={handleSmsChannel}
                    className="accent-neutral-800 dark:accent-neutral-600 w-5 h-5 border-neutral-300 rounded"
                    defaultChecked
                  />
                  <label
                    htmlFor="channel-sms"
                    className="text-neutral-800 dark:text-white text-base flex items-center gap-2 cursor-pointer"
                  >
                    <i className="fa-solid fa-comment-sms text-blue-500"></i>{" "}
                    SMS
                  </label>
                </div>
                <div className="flex items-center space-x-2">
                  <input
                    id="channel-whatsapp"
                    name="channel-whatsapp"
                    type="checkbox"
                    onChange={handleWhatsappChannel}
                    defaultChecked
                    className="accent-green-600 w-5 h-5 border-neutral-300 rounded"
                  />
                  <label
                    htmlFor="channel-whatsapp"
                    className="text-neutral-800 dark:text-white text-base flex items-center gap-2 cursor-pointer"
                  >
                    <i className="fa-brands fa-whatsapp text-green-600"></i>{" "}
                    WhatsApp
                  </label>
                </div>
              </div>
            </div>

            <div className="space-y-4">
              <label className="block text-base font-medium text-neutral-800 dark:text-white mb-2">
                WhatsApp Template
              </label>
              <select
                value={selectedTemplate?.id || ''}
                onChange={(e) => handleTemplateChange(e.target.value)}
                className="w-full rounded-lg border dark:border-neutral-700 px-4 py-2 focus:ring-2 focus:ring-neutral-800 dark:focus:ring-neutral-600 focus:outline-none text-neutral-900 dark:text-white bg-white dark:bg-neutral-700"
              >
                <option value="">Select a template</option>
                {whatsappTemplates.map((template) => (
                  <option key={template.id} value={template.id}>
                    {template.name} ({template.category}) - {template.parameter_format} - {template.status}
                  </option>
                ))}
              </select>

              {renderTemplateFields()}
            </div>
            <div className="space-y-1">
              <label
                htmlFor="notif-message"
                className="block text-base font-medium text-neutral-800 dark:text-white"
              >
                <span>SMS Text</span>

                <p className="text-m text-neutral-600 dark:text-neutral-400 italic">
                  <label
                    htmlFor="sms-custom-text"
                    className="text-neutral-800 dark:text-white text-base flex items-center gap-2 cursor-pointer"
                  > <input
                      name="sms-custom-text"
                      type="checkbox"
                      onChange={handleSmsTextOption}
                      className="accent-black-600 w-5 h-5 border-neutral-300 rounded"
                    />
                    Use custom message below instead of Whatsapp Template's Body
                  </label>
                </p>

              </label>
              <textarea
                id="notif-message"
                rows={4}
                disabled={isWhatsappBodySms}
                maxLength={280}
                className="w-full rounded-lg border dark:border-neutral-700 px-4 py-3 focus:ring-2 focus:ring-neutral-800 dark:focus:ring-neutral-600 focus:outline-none text-neutral-900 dark:text-white text-base placeholder:text-neutral-400 dark:placeholder:text-neutral-500 transition resize-none bg-white dark:bg-neutral-700"
                placeholder="Type your notification message"
                onChange={(e: any) => handleSmsText(e?.target?.value)}
              ></textarea>

              <div className="text-xs text-neutral-400 dark:text-neutral-500 text-right mt-1">
                Max 280 characters
              </div>
            </div>


            {sendStatus && (
              <div
                className={`p-4 rounded-lg ${sendStatus.success
                  ? "bg-green-100 dark:bg-green-900"
                  : "bg-red-100 dark:bg-red-900"
                  }`}
              >
                <p
                  className={`text-sm ${sendStatus.success
                    ? "text-green-800 dark:text-green-200"
                    : "text-red-800 dark:text-red-200"
                    }`}
                >
                  {sendStatus.message}
                </p>
              </div>
            )}

            <div className="pt-4">
              <button
                type="submit"
                onClick={(e) => {
                  // handleSendSms();
                  // _handleSubmit(e)
                }}
                className="w-full bg-neutral-800 dark:bg-neutral-600 hover:bg-neutral-700 dark:hover:bg-neutral-500 transition text-white font-semibold text-lg py-3 rounded-lg shadow-lg flex items-center justify-center gap-2"
              >
                <i className="fa-solid fa-paper-plane"></i>
                Send Notification
              </button>
            </div>
          </form>
        </div>
      </main>


      {renderConfirmationModal()}
      {sendStatus?.success == true && renderSendSuccess()}
    </div>
  );
}
